import clsx from "clsx";
import styles from "./CompaniesDropdown.module.scss";
import { Typography } from "@/frontend/shared/ui/Typography";
import { Dispatch, MouseEvent, RefObject, useMemo } from "react";
import { Loader } from "@/frontend/shared/ui/Loader/Loader";
import { Portal } from "@/frontend/shared/ui/Drawer/components/Portal";
// import { PlusIcon } from "@/frontend/shared/assets/icons";
// import { NormalButton } from "@/frontend/shared/ui/Button";
import { ESection } from "../EditCompetitorsModal/EditCompetitorsModal";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { PlusIcon } from "@/frontend/shared/assets/icons";

export type TFormattedSearchedCompanies = {
  id: number;
  name: string;
  headline: string;
  logoUrl: string;
  website: string;
  linkedInUrl: string;
};

type TCompaniesDropdown = {
  className: string;
  inputValue: string;
  setInputValue: (value: string) => void;
  options: TFormattedSearchedCompanies[];
  isOpen: boolean;
  onClose: () => void;
  isCompaniesLoading?: boolean;
  setSection: (section: ESection) => void;
  companiesContainerRef?: RefObject<HTMLDivElement>;
  setCompetitorsData: Dispatch<React.SetStateAction<TFormattedSearchedCompanies[]>>;
};

export function CompaniesDropdown({
  className,
  inputValue,
  options,
  isOpen,
  onClose,
  isCompaniesLoading,
  setSection,
  companiesContainerRef,
  setCompetitorsData
}: TCompaniesDropdown) {
  function addCompanyToCompetitors(company: TFormattedSearchedCompanies) {
    setCompetitorsData((prev) => [...prev, company]);
    onClose();
  }

  const content = useMemo(() => {
    switch (true) {
      case isCompaniesLoading:
        return (
          <div className={styles.loadingContainer}>
            <Loader />
          </div>
        );
      case options?.length > 0:
        return options?.map((company, index) => (
          <div key={company.id} className={styles.option} onClick={() => addCompanyToCompetitors(company)}>
            <img src={company.logoUrl} alt={company.name} />
            <div>
              <Typography variant="label-4" color="greyscale800" className={styles.name}>
                {company.name}
              </Typography>
              <Typography variant="body-3" color="greyscale600" className={styles.headline}>
                {company.headline}
              </Typography>
            </div>
          </div>
        ));
      default:
        null;
    }
  }, [inputValue, options, isCompaniesLoading]);

  function onAddCompanyClick(e: MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    setSection(ESection.ADD_COMPETITOR);
    onClose();
  }

  return (
    <Portal containerId="editModalContainer">
      <div className={clsx(styles.container, isOpen && styles.isOpen, className)} ref={companiesContainerRef}>
        {content}
        <div className={clsx(styles.inputTextContainer)}>
          <NormalButton
            className={styles.addCompanyBtn}
            size="medium"
            variant="secondary"
            onClick={(e) => onAddCompanyClick(e)}
          >
            <PlusIcon />
            <Typography variant="label-4" color="greyscale800">
              Add Company
            </Typography>
          </NormalButton>
        </div>
      </div>
    </Portal>
  );
}
